// API Configuration
// Centralized configuration for all backend services

const CONFIG = {
    EMPLOYEE_SERVICE_URL: "https://6a9jrkbckd.execute-api.us-east-2.amazonaws.com/api",
    // EMPLOYEE_SERVICE_URL: "http://localhost:5000/api",
    REPORTS_SERVICE_URL: "https://6a9jrkbckd.execute-api.us-east-2.amazonaws.com/reports",
    // REPORTS_SERVICE_URL: "http://localhost:5000",
    SMART_TOOLS_URL: "https://6a9jrkbckd.execute-api.us-east-2.amazonaws.com/smart-tools",
    // SMART_TOOLS_URL: "http://localhost:5000",
    CUSTOMER_SERVICE_URL: "https://6a9jrkbckd.execute-api.us-east-2.amazonaws.com/customer-service",
};

export default CONFIG;
